module.exports = __webpack_public_path__ + "static/media/THE WHITEHART MENU Feb 2024.d026694c.pdf";